import { getContext } from '@fiverr-private/fiverr_context';

export const getClientDevice = () => (getContext().isTouch ? 'mobile' : 'desktop');
